import {
  InventoryData,
  PlanTypes,
  ProductSide,
  Status,
} from "../../../../types/inventoryData";
import { JSXElementConstructor, ReactElement } from "react";

export type HeadCell = {
  id: keyof InventoryData;
  label: string;
  minwidth?: number;
  disablePadding: boolean;
  align?: "right";
  numeric: boolean;
  visible: boolean;
  editable: boolean;
  getValue: (row: InventoryData) => string | number | null | undefined;
  formatValue?: (value: any | PlanTypes | InventoryData) => string | null;
};

export const headCellsOG: HeadCell[] = [
  {
    id: "productType",
    label: "labels.product",
    numeric: false,
    disablePadding: true,
    visible: true,
    editable: false,
    getValue: (row) => row.productType.name,
    formatValue: (row) => {
      // const side =
        // row.productType.productTypeId == 20 ? ProductSide[row.side] : "";
      return `${row.productType.name} ${parseInt(
        row.serial.slice(-4),
        10
      )}`;
    },
  },
  {
    id: "size",
    label: "labels.size",
    numeric: true,
    disablePadding: true,
    visible: true,
    editable: false,
    getValue: (row) => row.size,
  },
  {
    id: "side",
    label: "labels.side",
    numeric: false,
    disablePadding: true,
    visible: true,
    editable: false,
    getValue: (row) => ProductSide[row.side],
  },
  {
    id: "status",
    label: "labels.status",
    numeric: false,
    disablePadding: true,
    visible: true,
    editable: true,
    getValue: (row) => Status[row.status],
    formatValue: (row) => Status[row],
  },
  {
    id: "location",
    label: "inventory.location",
    numeric: false,
    disablePadding: true,
    visible: true,
    editable: true,
    getValue: (row) => row.location,
  },
  {
    id: "note",
    label: "inventory.note",
    numeric: false,
    disablePadding: true,
    visible: true,
    editable: true,
    getValue: (row) => row.note,
  },
  {
    id: "plan",
    label: "inventory.plan",
    numeric: false,
    disablePadding: true,
    visible: true,
    editable: true,
    getValue: (row) => row.plan?.companyName,
    formatValue: (plan) => plan.companyName,
  },
  {
    id: "serial",
    label: "labels.serial",
    numeric: false,
    disablePadding: true,
    visible: true,
    editable: false,
    getValue: (row) => row.serial,
  },
  {
    id: "batchnumber",
    label: "labels.batchNumber",
    numeric: false,
    disablePadding: true,
    visible: true,
    editable: false,
    getValue: (row) => row.batchnumber,
  },
  {
    id: "actions",
    label: "labels.actions",
    numeric: false,
    disablePadding: true,
    visible: true,
    editable: false,
    getValue: (row) => null,
  },
];
